// extracted by mini-css-extract-plugin
export default {"alert":"group__alert","save_form":"group__save_form","control":"group__control","group_switch":"group__group_switch","hidden":"group__hidden"};